export enum MeasurerCategory {
  SENSOR = 'SENSOR',
  CALCULATOR = 'CALCULATOR',
}
